var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('PageTitle',{attrs:{"title":"Página no encontrada"}})],1),_c('b-col',{staticClass:"text-center",attrs:{"cols":"12"}},[_c('h1',{staticClass:"p-5",staticStyle:{"font-size":"100px"}},[_vm._v("404")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }